export default {
    namespaced: true,

    actions: {
        initialize() {
            console.info('Campus addresses module initalizing..')
            console.info('Campus addresses module initalized.')
        }
    },

    state: {
        portalItem: {
            id: "71d3d1ce930b405db3cccacb658780c8"
        },
        additionalResources: [
            {
                title: 'CAMPUS ADDRESSES DOWNLOAD',
                url: 'https://services.gis.msu.edu/facility-data/v1/resources/campusAddressCollection.cfc?method=getAsXlsx'
            },
            {
                title: 'USPS ADDRESSING STANDARDS',
                url: 'https://pe.usps.com/text/pub28/welcome.htm'
            },
            {
                title: 'UNIVERSITY SERVICES',
                url: 'https://usd.msu.edu/'
            },
            {
                title: 'CAMPUS MAPS',
                url: 'https://maps.msu.edu'
            },
            {
                title: 'MSU POLICE',
                url: 'https://police.msu.edu/'
            }
        ]
    }
}
